import { render, staticRenderFns } from "./GiftProductSelector.vue?vue&type=template&id=acf757ea&"
import script from "./GiftProductSelector.vue?vue&type=script&lang=js&"
export * from "./GiftProductSelector.vue?vue&type=script&lang=js&"
import style0 from "./GiftProductSelector.vue?vue&type=style&index=0&id=acf757ea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports